import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "./index.scss";

const consultants = Array(10).fill({
  name: "Arij hachfi",
  title: "Consultant",
});

const ConsultantProfiles = () => {
  return (
    <div className="consultants-section">
      <div className="consultants-section-Container">
        <Row className="justify-content-between align-items-center mb-4">
          <Col md={8}>
            <h2 className="section-title">Nos Consultants</h2>
            <p className="section-description">
              Notre cabinet de conseil s’appuie sur une équipe
              pluridisciplinaire
              <br />
              d’experts passionnés, sélectionnés pour leur excellence technique
            </p>
          </Col>
          <Col md={4} className="text-md-end text-start mt-3 mt-md-0">
            <Button className="see-more-btn">Voir Plus</Button>
          </Col>
        </Row>

        <Row className="g-3">
          {consultants.map((consultant, index) => (
            <Col key={index} xs={6} md={3}>
              <Card className="consultant-card text-center">
                <Card.Body>
                  <Card.Title className="name">{consultant.name}</Card.Title>
                  <Card.Text className="role">{consultant.title}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ConsultantProfiles;
